/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { useIntl } from 'react-intl';
import { EmbersLink } from '../../link/link';
import { PageTemplate } from '../../templates/pageTemplate';
import { ContentTemplate } from '../../templates/contentTemplate';
import ServiceUnavailableErrorImage from './assets/image-error-503.svg';
import { useDocumentTitle } from '../../utils/useDocumentTitle';
export var ServiceUnavailableError = function ServiceUnavailableError(_ref) {
  var onBack = _ref.onBack,
    activityId = _ref.activityId,
    timeStamp = _ref.timeStamp;
  var intl = useIntl();
  useDocumentTitle(intl.formatMessage({
    id: 'embers.pageTitle.error.serviceUnavailable',
    defaultMessage: 'Service unavailable - Promethean'
  }));
  return /*#__PURE__*/React.createElement(PageTemplate, null, /*#__PURE__*/React.createElement(ContentTemplate, {
    type: "error",
    pageTitle: intl.formatMessage({
      id: 'embers.globalError.serviceUnavailable.title',
      defaultMessage: 'Service unavailable'
    }),
    errorMessage: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, intl.formatMessage({
      id: 'embers.globalError.serviceUnavailable.description',
      defaultMessage: '{boldMessage} Please try again later, or if you keep seeing this message please visit {supportLink}.'
    }, {
      boldMessage: /*#__PURE__*/React.createElement("span", {
        style: {
          fontWeight: 700
        }
      }, intl.formatMessage({
        id: 'embers.globalError.serviceUnavailable.notice',
        defaultMessage: 'We’re working to fix this as soon as possible.'
      })),
      supportLink: /*#__PURE__*/React.createElement(EmbersLink, {
        className: "support-link",
        href: "https://support.prometheanworld.com/s/contact-us",
        target: "_blank",
        rel: "noreferrer"
      }, intl.formatMessage({
        id: 'embers.support',
        defaultMessage: 'Promethean Support'
      }))
    })), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("p", null, intl.formatMessage({
      id: 'embers.globalError.serviceUnavailable.activityID',
      defaultMessage: 'ActivityID: '
    }), activityId), /*#__PURE__*/React.createElement("p", null, intl.formatMessage({
      id: 'embers.globalError.serviceUnavailable.date',
      defaultMessage: 'Date and time: '
    }), timeStamp)),
    errorImage: ServiceUnavailableErrorImage,
    onBack: onBack
  }));
};